var map = {
	"./default/en.json": [
		15
	],
	"./en-GB.json": [
		39,
		4
	],
	"./en.json": [
		40,
		5
	],
	"./it.json": [
		41,
		6
	],
	"./pl.json": [
		42,
		7
	],
	"./pt-BR.json": [
		43,
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 35;
module.exports = webpackAsyncContext;